import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const style = {
  wrapper: {
    width: '100%',
    height: '100%',
  },
  iframe: {
    width: '100%',
    height: 'calc(100% - 84px)',
  },
};

class Iframe extends PureComponent {
  render() {
    const { src, active, tab } = this.props;
    const className = `gmTabs__panel ${(active) ? 'is-active' : ''}`;

    return (
      <div style={style.wrapper} className={className}>
        <iframe
          id={tab.key}
          src={src}
          style={style.iframe}
          sandbox="allow-scripts allow-forms allow-same-origin allow-downloads allow-modals allow-presentation"
        />
      </div>
    );
  }
}

Iframe.defaultProps = {
  active: false,
};

Iframe.propTypes = {
  active: PropTypes.bool,
  tab: PropTypes.objectOf(PropTypes.any),
  src: PropTypes.string.isRequired,
}

export default Iframe;
